import { render } from "./ClientsList.vue?vue&type=template&id=2b906554&ts=true"
import script from "./ClientsList.vue?vue&type=script&lang=ts"
export * from "./ClientsList.vue?vue&type=script&lang=ts"

import "./ClientsList.vue?vue&type=style&index=0&id=2b906554&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__